import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

export interface ErrorsInterface {
  logger(error: any): void;
}

export class Errors implements ErrorsInterface {
  sentry: any = null;
  constructor(Vue) {
    if (!!this.sentry || process.env.NODE_ENV === "development") {
      return;
    }

    this.sentry = Sentry;
    this.sentry.init({
      Vue,
      dsn: process.env.VUE_APP_SENTRY_API_KEY,
      environment: process.env.VUE_APP_ENV_NAME,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
      logErrors: true,
    });
  }

  /***
   * Logger error method
   * @param error
   * @return {void}
   */
  logger(error: any): void {
    this.sentry.captureException(error);
    this.sentry.captureMessage(error);
  }
}
